export default __webpack_public_path__ + "static/media/Bitcoin-Logo.443a278f.png";